import { useMutation } from '@apollo/client';
import type { IOnUploadOptionsProps } from 'dash-ui';

import { draftFileUploadMutation } from 'gql/file/mutations';

const useFormDraftFileUpload = () => {
  const [draftFileUpload] = useMutation(draftFileUploadMutation);

  return (
    file: File,
    { onProgress, onCompleted, onError, setAbortHandler }: IOnUploadOptionsProps
  ) =>
    draftFileUpload({
      variables: { input: { file } },
      onCompleted: (file) => onCompleted(file.uploadDraftFile),
      onError: onError,
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: ({ loaded, total }: ProgressEvent) =>
            onProgress(Number((loaded / total) * 100)),
          onAbort: (abortHandler: () => void) =>
            setAbortHandler && setAbortHandler(abortHandler),
        },
      },
    });
};

export default useFormDraftFileUpload;
